import { Hit } from '@core/ts/algolia';
import { VoyagerResult } from '@core/ts/results';

export const mapHitsToResults = (hits: Hit[]) => {
  const results: VoyagerResult[] = hits.map(({ program, school, cap, url, meta, __position }: Hit) => {
    const result: VoyagerResult = {
      cap,
      school,
      program,
      url,
      meta,
      __position: __position ?? 0,
    };
    return result;
  });
  return results;
};
